import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import type { FileData } from "@/services/files";
import type { NoteTemplate } from "@/common/types/notesTemplates";
import { UseUpdateTemplateType } from "@/hooks/notesTemplates/useUpdateTemplateFactory";
import { CardContentTemplateUpdate } from "./CardContentTemplateUpdate";
import { t } from "i18next";

interface Props {
  file: FileData;
  notes: NoteTemplate[];
  refresh: () => void;
}

export const VisitTemplateViewer = (props: Props): React.ReactNode => {
  return (
    <Card>
      <CardHeader className="bg-grey-white rounded-t-lg p-0">
        <CardTitle className="text-lg font-bold p-6">
          {t("visit.components.visitTemplateViewer.title")}
        </CardTitle>
      </CardHeader>
      <CardContentTemplateUpdate
        file={props.file}
        refresh={props.refresh}
        type={UseUpdateTemplateType.VISIT}
      />
      {props.notes.map((note, index) => (
        <CardContentTemplateUpdate
          key={index}
          file={note}
          refresh={props.refresh}
          type={UseUpdateTemplateType.NOTE}
        />
      ))}
    </Card>
  );
};
